export default __webpack_public_path__ + "static/media/thrivingpets-logo-d3.17200f09.svg";